// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-3MbzhR3t"};